// extracted by mini-css-extract-plugin
module.exports = {"emptyResults":"_2jDd9XWfKvNsp7Gds83fhh","depositsDisclosures":"_1iYzqZ-QkIzaReXKj0t6ML"};